export function medicinesData () {
    var medList = [
            {
                src: require("../../static/medicines/jingkangfu.jpg"),
                id: 1,
                name: '颈复康颗粒',
                company: '颈复康药业集团有限公司',
                usage: '开水冲服。一次1mdash；2袋。一日2次，饭后服。',
                functions: '活血通络，散风止痛。用于风湿瘀阻所致的颈椎病，症见头晕，颈项僵硬，肩背酸痛。',
                type: '颗粒剂',
                application: '1.本品具有明显的抗炎和镇痛作用。在改善颈部疼痛、肢体麻木、头痛、眩晕等方面均有显著疗效。 2.本品能降低脑血管阻力，增加脑血流量。 3.对缺血心肌具有明显的保护作用，能增加心脏的冠脉流量(p﹤0.01)，增强心肌收缩力。 4.能改善血液流变学和微循环状况，能明显扩张微动脉口径，增加毛细血管开放数；降低全血粘度、血浆粘度纤维蛋白原粘度及红细胞压积(p≤0.05)。 5.毒理学实验：小鼠灌胃最大耐受量360g生药/kg，相当于临床用药的210倍。',
                ingredients: '羌活、川芎、葛根、秦艽、威灵仙、苍术、丹参、白芍、地龙(酒炙)、红花、乳香(制)、黄芪、党参、地黄、石决明、花蕊石(煅)、黄柏、王不留行(炒)、桃仁(去皮）、没药(制)、土鳖虫(酒炙)。辅料为乳糖、β-环糊精、硬脂酸镁。',
                reactions: '尚不明确。',
                cautions: '1.忌生冷、油腻食物。2.有高血压、心脏病、肝病、糖尿病、肾病等慢性病严重者应在医师指导下服用。3.儿童、经期及哺乳 期妇女、年老体弱者应在医师指导下服用。4.消化道溃疡、肾性高血压患者慎服或遵医嘱。5.如有感冒、发烧、鼻咽痛等患者，应暂停服用。6.头晕或手臂麻 木严重者，应去医院就诊。7.服药7天症状无缓解，应去医院就诊。8.对本品过敏者禁用，过敏体质者慎用。9.本品性状发生改变时禁止使用。10.儿童必 须在成人监护下使用。11.请将本品放在儿童不能接触的地方。'
            },
            {
                src: require("../../static/medicines/xiaotongtie.jpg"),
                id: 2,
                name: '奇正(消痛贴膏)',
                company: '西藏奇正藏药股份有限公司',
                usage: '外用。将小袋内润湿剂均匀涂在药垫表面，润湿后直接敷于患处或穴位。每贴敷24小时。',
                functions: '活血化瘀，消肿止痛。用于急慢性扭挫伤、跌打瘀痛、骨质增生、风湿及类风湿疼痛。',
                type: '贴膏剂',
                application: '能够加速血液循环，增强细胞活力，促进新陈代谢，调整生理功能，达到快速消炎、止痛的效果。',
                ingredients: '本品系藏族验方：国家保密方',
                reactions: '过敏型体质患者可能有胶布过敏或药物接触性瘙痒反应，甚至出现红肿、水泡等。',
                cautions: '1.皮肤破伤处不宜使用。 2.皮肤过敏者停用。 3.孕妇慎用。小儿、年老患者应在医师指导下使用。 4.对本品过敏者禁用，过敏体质者慎用。 5.本品性状发生改变时禁止使用。 6.儿童必须在成人的监护下使用。 7.请将本品放在儿童不能接触的地方。 8.如正在使用其他药品，使用本品前请咨询医师或药师。'
            },
            {
                src: require("../../static/medicines/yunnanbaiyao.jpg"),
                id: 3,
                name: '云南白药膏',
                company: '云南白药集团无锡药业有限公司',
                usage: '贴患处。',
                functions: '活血散瘀，消肿止痛，祛风除湿。用于跌打损伤，瘀血肿痛，风湿疼。',
                type: '橡胶膏剂',
                application: '如与其他药物同时使用可能会发生药物相互作用，详情请咨询医师或药师。',
                ingredients: '国家保密方。',
                reactions: '过敏性体质患者可能有胶布过敏反应或药物接触性瘙痒反应。遇此，贴用时间不宜超过12小时。偶见红肿、水泡等，遇此应停药。',
                cautions: '1.皮肤破伤处不宜使用。 2.皮肤过敏者停用。 3.每次贴于皮肤的时间少于12小时，使用中发生皮肤发红，瘙痒等轻微反应时可适当减少粘贴时间。 4.小儿、年老患者应在医师指导下使用。 5.对本品过敏者禁用，过敏体质者慎用。 6.本品性状发生改变时禁止使用。 7.儿童必须在成人的监护下使用。 8.请将本品放在儿童不能接触的地方。 9.如正在使用其他药品，使用本品前请咨询医师或药师。'
            },
            {
                src: require("../../static/medicines/huanglian.png"),
                id: 4,
                name: '黄连上清片',
                company: '北京同仁堂科技发展股份有限公司制药厂',
                usage: '口服。一次6片，一日2次。',
                functions: '清热通便，散风止痛。用于内热火盛引起的头晕脑胀，牙龈肿痛。',
                type: '片剂',
                application: '如与其他药物同时使用可能会发生药物相互作用，详情请咨询医师或药师。',
                ingredients: '黄连、大黄、栀子（姜制）、黄芩、菊花、连翘、蔓荆子（炒）、荆芥穗、薄荷、黄柏（酒炒）、防风、旋覆花、石膏、桔梗、白芷、甘草、川芎。',
                reactions: '尚不明确。',
                cautions: '1.忌服辛辣刺激等食物。 2.不宜在服药期间同时服用温补性中成药。 3.心脏病、肝病、糖尿病、肾病等慢性病严重者应在医师指导下服用。 4.严格按用法用量服用，小儿、年老体弱患者，大便溏软者应在医师指导下服用。 5.服药3天后症状未改善，或出现其他严重症状时，应到医院就诊。 6.对本品过敏者禁用,过敏体质者慎用。 7.药品性状发生改变时禁止服用。 8.儿童必须在成人的监护下使用。 9.请将此药品放在儿童不能接触的地方。 10.如正在服用其他药品，使用本品前请咨询医生或药师。'
            },
            {
                src: require("../../static/medicines/shangqingwan.png"),
                id: 5,
                name: '黄连上清丸',
                company: '北京同仁堂科技发展股份有限公司制药厂',
                usage: '口服。一次12丸，一日2次',
                functions: '散风清热，泻火止痛。用于风热上攻、肺胃热盛所致的头晕目眩。',
                type: '蜜丸',
                application: '如与其他药物同时使用可能会发生药物相互作用，详情请咨询医师或药师。',
                ingredients: '黄连、栀子(姜制)、连翘、炒蔓荆子、防风、荆芥穗、白芷、黄苓、菊花、薄荷、酒大黄、黄柏(酒炒)、桔梗、川芎、石膏、旋覆花、甘草。辅料为赋形剂蜂蜜。',
                reactions: '尚不明确。',
                cautions: '1.忌烟、酒及辛辣食物。 2.不宜在服药期间同时服用滋补性中药。 3.有高血压、心脏病、肝病、糖尿病、肾病等慢性病严重者应在医师指导下服用。 4.服药后大便次数增多且不成形者，应酌情减量。 5.孕妇慎用，儿童、哺乳期妇女，年老体弱者应在医师指导下服用。 6.严格按用法用量服用，本品不宜长期服用。 7.服药3天症状无缓解，应去医院就诊。 8.对本品过敏者禁用，过敏体质者慎用。 9.本品性状发生改变时禁止使用。 10.儿童必须在成人监护下使用。 11.请将本品放在儿童不能接触的地方。'
            },
            {
                src: require("../../static/medicines/tianzhengwan.jpg"),
                id: 6,
                name: '正天丸',
                company: '华润三九医药股份有限公司',
                usage: '饭后服。一次6克，一日2～3次，15天为一个疗程',
                functions: '疏风活血，养血平肝，通络止痛。用于外感风邪、瘀血阻络。',
                type: '水丸',
                application: '如与其他药物同时使用可能会发生药物相互作用，详情请咨询医师或药师。',
                ingredients: '钩藤、白芍、川芎、当归、地黄、白芷、防风、羌活、桃仁、红花、细辛、独活、麻黄、附片、鸡血藤。辅料为药用炭、淀粉、单糖浆、虫白蜡。',
                reactions: '个别病例服药后谷丙转氨酶轻度升高；偶有口干、口苦、腹痛及腹泻。',
                cautions: '1.忌烟、酒及辛辣、油腻食物。 2.高血压、心脏病患者慎服。有肝病、糖尿病、肾病等慢性病严重者应在医师指导下用药。 3.儿童、孕妇、哺乳期妇女及年老体弱者应在医师指导下服用。 4.高血压头痛及不明原因的头痛，应去医院就诊。 5.初发头痛服药3天症状无缓解，应去医院就诊。经常性头痛服药15天症状无缓解，应去医院就诊。 6.严格按用法用量服用。 7.运动员慎用。 8.对本品过敏者禁用，过敏体质者慎用。 9.本品性状发生改变时禁止使用。 10.请将本品放在儿童不能接触的地方。'
            },
            {
                src: require("../../static/medicines/yangyin.jpg"),
                id: 7,
                name: '养阴清肺丸',
                company: '北京同仁堂股份有限公司同仁堂制药厂',
                usage: '口服。一次6克，一日2次。',
                functions: '养阴润燥，清肺利咽。用于阴虚肺燥，咽喉干痛，干咳少痰。',
                type: '蜜丸',
                application: '如与其他药物同时使用可能会发生药物相互作用，详情请咨询医师或药师。',
                ingredients: '地黄、麦冬、玄参、川贝母、白芍、牡丹皮、薄荷、甘草。辅料为赋形剂蜂蜜。',
                reactions: '尚不明确。',
                cautions: '1.忌烟、酒及辛辣、生冷、油腻食物。 2.支气管扩张、肺脓疡、肺心病、肺结核患者出现咳嗽时应去医院就诊。 3.有高血压、心脏病、肝病、糖尿病、肾病等慢性病严重者应在医师指导下服用。 4.儿童、孕妇、哺乳期妇女、年老体弱者应在医师指导下服用。 5.服药期间，若患者发热体温超过38.5℃，或出现喘促气急者，或咳嗽加重、痰量明显增多者应去医院就诊。 6.服药7天症状无缓解，应去医院就诊。 7.对本品过敏者禁用，过敏体质者慎用。 8.本品性状发生改变时禁止使用。 9.儿童必须在成人监护下使用。10.请将本品放在儿童不能接触的地方。 '
            },
            {
                src: require("../../static/medicines/feining.jpg"),
                id: 8,
                name: '肺宁颗粒',
                company: '修正药业集团股份有限公司',
                usage: '开水冲服。一次10克，一日3次。',
                functions: '清热祛痰，止咳。用于慢性支气管炎咳嗽。',
                type: '颗粒剂',
                application: '治肺 肺宁颗粒的药物成分返魂草主要含有氢醌、对羟基苯乙酸、熊果酸、黄酮类、倍半萜类、生物碱等主要成分，对金黄色葡萄球菌、白色葡萄球菌、卡它球菌和变形球菌、乙型链球菌等有较强杀灭抑制作用。 清肺 药物成分中产生的活性因子可与肺细胞内的肺痰、毒素、沉淀物等肺部垃圾充分结合使其溶解，并通过人体自身新陈代谢排出体外，清除肺部垃圾。 护肺 肺宁颗粒可在病灶部位形成保护障，并在阻断病菌入侵的同时修复气管壁、肺泡等部受损细胞，防止复发。 养肺 肺宁颗粒还包含了多种生物活性营养成分。在治疗疾病的同时，充分调理人体的脏腑功能，提高自身免疫力，真正彻底的防止多种疾病的侵入。',
                ingredients: '返魂草。辅科为：蔗糖粉。',
                reactions: '尚不明确。',
                cautions: '1.忌烟、酒及辛辣、香燥、生冷、油腻食物。 2.不宜在服药期间同时服用滋补性中药。 3.有支气管扩张、肺脓疡、肺心病、肺结核患者出现咳嗽时应去医院就诊。 4.服药3天症状无缓解，应去医院就诊。 5.儿童、年老体弱者、孕妇应在医师指导下服用。 6.对本品过敏者禁用，过敏体质者慎用。 7.本品性状发生改变时禁止使用。 8.儿童必须在成人监护下使用。 9.请将本品放在儿童不能接触的地方。 10.如正在使用其他药品，使用本品前请咨询医师或药师。'
            },
            {
                src: require("../../static/medicines/tongxuan.jpg"),
                id: 9,
                name: '通宣理肺丸',
                company: '北京同仁堂股份有限公司同仁堂制药厂',
                usage: '口服。一次2丸，一日23次。',
                functions: '解表散寒，宣肺止嗽。用于风寒束表、肺气不宣所致的感冒咳嗽。',
                type: '蜜丸',
                application: '如与其他药物同时使用可能会发生药物相互作用，详情请咨询医师或药师。',
                ingredients: '紫苏叶、前胡、桔梗、苦杏仁、麻黄、甘草、陈皮、半夏(制)、茯苓、枳壳(炒)、黄芩。辅料为赋形剂蜂蜜。',
                reactions: '尚不明确。',
                cautions: '1.忌烟、酒及辛辣、生冷、油腻食物。 2.不宜在服药期间同时服用滋补性中药。 3.风热或痰热咳嗽、阴虚干咳者不适用。 4.支气管扩张、肺脓疡、肺心病、肺结核患者出现咳嗽时应去医院就诊。 5.高血压、心脏病患者慎用。有肝病、糖尿病、肾病等慢性病严重者应在医师指导下服用。 6.儿童、孕妇、哺乳期妇女、年老体弱者应在医师指导下服用。 7.服药期间，若患者发热体温超过38.5℃，或出现喘促气急者，或咳嗽加重、痰量明显增多者应去医院就诊。 8.服药3天症状无缓解，应去医院就诊。 9.运动员慎用。'
            },
            {
                src: require("../../static/medicines/fengjiao.jpg"),
                id: 10,
                name: '蜂胶口腔膜',
                company: '北京紫竹药业有限公司',
                usage: '用时剪下一片直接贴于患处，一日3次',
                functions: '清热止痛。用于复发性口疮',
                type: '膜剂',
                application: '如与其他药物同时使用可能会发生药物相互作用，详情请咨询医师或药师。',
                ingredients: '本品每片含蜂胶膏、薄荷脑。辅料为甘油、聚山梨酯(吐温)、胡精钠、聚维酮K(PVP)、聚乙烯醇树酯。',
                reactions: '尚不明确。',
                cautions: '1.忌烟、酒及辛辣、油腻食物。 2.不宜在用药期间同时服用温补性中药。 3.孕妇慎用、儿童及年老体弱者应在医师指导下使用。 4.使用中如出现局部红肿、皮疹、头晕、呕吐、恶心等症状者应停用，症状严重者应去医院就诊。 5.用药3天症状无缓解、应去医院就诊。 6.对本品过敏者禁用，过敏体质者慎用。 7.本品性状发生改变时禁止使用。 8.儿童必须在成人监护下使用。 9.请将本品放在儿童不能接触的地方。 10.如正在服用其他药品，使用本品前请咨询医师或药师。'
            },
        ]
        return medList
}



// WEBPACK FOOTER //
// ./src/util/medicines.js